import { ReactComponent as CustomerServiceSolid } from "../icons/customer-service-01-solid-standard.svg"
import { ReactComponent as CircleArrowRight } from "../icons/circle-arrow-right-02-solid-standard.svg"
import { ReactComponent as CheckmarkSquare } from "../icons/checkmark-square-01-solid-rounded.svg"
import { ReactComponent as ConferenceSolidStandard } from "../icons/conference-solid-standard.svg"
import { ReactComponent as ListSolid } from "../icons/left-to-right-list-dash-solid-standard.svg"
import { ReactComponent as UserMultipleSolid } from "../icons/user-multiple-02-solid-rounded.svg"
import { ReactComponent as CloudDownloadSolid } from "../icons/cloud-download-solid-rounded.svg"
import { ReactComponent as InvoiceStrokeRounded } from "../icons/invoice-01-stroke-rounded.svg"
import { ReactComponent as ArrowRight2 } from "../icons/arrow-right-double-stroke-rounded.svg"
import { ReactComponent as ArrowRightUp } from "../icons/rightarrow-up.svg"
import { ReactComponent as AttachmentStrokeSharp } from "../icons/attachment-stroke-sharp.svg"
import { ReactComponent as ThumbsDownStroke } from "../icons/thumbs-down-stroke-standard.svg"
import { ReactComponent as ArrowRight1 } from "../icons/arrow-right-01-stroke-standard.svg"
import { ReactComponent as Checkmark } from "../icons/checkmark-circle-01-stroke-sharp.svg"
import { ReactComponent as ForumBookmark } from "../icons/file-bookmark-solid-standard.svg"
import { ReactComponent as ResetPassword } from "../icons/reset-password-solid-rounded.svg"
import { ReactComponent as ThumbsDownSolid } from "../icons/thumbs-down-solid-standard.svg"
import { ReactComponent as UserGroupSolid } from "../icons/user-group-03-solid-rounded.svg"
import { ReactComponent as ViewOffSolid } from "../icons/view-off-slash-solid-standard.svg"
import { ReactComponent as BookOpenSolid } from "../icons/book-open-02-solid-rounded.svg"
import { ReactComponent as Cross } from "../icons/multiplication-sign-stroke-rounded.svg"
import { ReactComponent as Appointment } from "../icons/appointment-02-solid-rounded.svg"
import { ReactComponent as ThumbsUpStroke } from "../icons/thumbs-up-stroke-standard.svg"
import { ReactComponent as CalendarSolid } from "../icons/calendar-03-solid-standard.svg"
import { ReactComponent as ComplaintSolid } from "../icons/complaint-solid-standard.svg"
import { ReactComponent as ForumLike } from "../icons/file-favourite-solid-standard.svg"
import { ReactComponent as EditSolid } from "../icons/pencil-edit-02-solid-standard.svg"
import { ReactComponent as ProgressStroke } from "../icons/progress-04-stroke-sharp.svg"
import { ReactComponent as SaleTagSolid } from "../icons/sale-tag-02-solid-standard.svg"
import { ReactComponent as ViewStrokeStandard } from "../icons/view-stroke-standard.svg"
import { ReactComponent as ThumbsUpSolid } from "../icons/thumbs-up-solid-standard.svg"
import { ReactComponent as ArrowDown } from "../icons/arrow-down-01-stroke-rounded.svg"
import { ReactComponent as HealtcareSolid } from "../icons/healtcare-solid-rounded.svg"
import { ReactComponent as ArrowDown1 } from "../icons/arrow-down-01-stroke-sharp.svg"
import { ReactComponent as ChatStrokeRounded } from "../icons/chat-stroke-rounded.svg"
import { ReactComponent as RadioSolid } from "../icons/radio-button-solid-rounded.svg"
import { ReactComponent as DeleteSolid } from "../icons/delete-03-solid-standard.svg"
import { ReactComponent as TwitterX } from "../icons/new-twitter-stroke-standard.svg"
import { ReactComponent as UploadSolid } from "../icons/upload-02-solid-standard.svg"
import { ReactComponent as Backward1 } from "../icons/backward-01-solid-rounded.svg"
import { ReactComponent as Facebook } from "../icons/facebook-02-solid-standard.svg"
import { ReactComponent as LinkedIn } from "../icons/linkedin-02-solid-standard.svg"
import { ReactComponent as MinusSolid } from "../icons/minus-sign-solid-rounded.svg"
import { ReactComponent as ShareSolid } from "../icons/share-01-solid-standard.svg"
import { ReactComponent as Instagram } from "../icons/instagram-stroke-rounded.svg"
import { ReactComponent as Draft } from "../icons/license-draft-solid-standard.svg"
import { ReactComponent as ImageSolid } from "../icons/image-03-solid-standard.svg"
import { ReactComponent as Comment1 } from "../icons/bubble-chat-solid-rounded.svg"
import { ReactComponent as SquareStroke } from "../icons/square-stroke-rounded.svg"
import { ReactComponent as WellnessSolid } from "../icons/wellness-solid-sharp.svg"
import { ReactComponent as Dribbble } from "../icons/dribbble-stroke-standard.svg"
import { ReactComponent as Alert } from "../icons/alert-circle-stroke-rounded.svg"
import { ReactComponent as PlusSolid } from "../icons/plus-sign-solid-rounded.svg"
import { ReactComponent as RouteSolid } from "../icons/route-01-solid-rounded.svg"
import { ReactComponent as SetupSolid } from "../icons/setup-02-solid-rounded.svg"
import { ReactComponent as TargetSolid } from "../icons/target-02-solid-sharp.svg"
import { ReactComponent as CircleStroke } from "../icons/circle-stroke-sharp.svg"
import { ReactComponent as Comment } from "../icons/comment-01-solid-rounded.svg"
import { ReactComponent as ForumAdd } from "../icons/file-add-solid-standard.svg"
import { ReactComponent as QuizSolid } from "../icons/quiz-01-solid-standard.svg"
import { ReactComponent as QuizSolid1 } from "../icons/quiz-05-solid-rounded.svg"
import { ReactComponent as SentPlane } from "../icons/sent-02-solid-standard.svg"
import { ReactComponent as TickSolid } from "../icons/tick-01-solid-standard.svg"
import { ReactComponent as ForumAll } from "../icons/file-01-solid-standard.svg"
import { ReactComponent as Search } from "../icons/search-01-solid-standard.svg"
import { ReactComponent as Heart } from "../icons/favourite-solid-standard.svg"
import { ReactComponent as Filter } from "../icons/filter-list-svgrepo-com.svg"
import { ReactComponent as Twitter } from "../icons/twitter-solid-standard.svg"
import { ReactComponent as TagSolid } from "../icons/tag-01-solid-rounded.svg"
import { ReactComponent as PlaySolid } from "../icons/play-solid-rounded.svg"
import { ReactComponent as Quote } from "../icons/quote-up-solid-rounded.svg"
import { ReactComponent as User1 } from "../icons/user-03-solid-rounded.svg"
import { ReactComponent as Menu } from "../icons/menu-11-stroke-rounded.svg"
import { ReactComponent as ViewSolid } from "../icons/view-solid-sharp.svg"
import { ReactComponent as Star } from "../icons/star-solid-standard.svg"
import { ReactComponent as Receipt } from "../icons/receipt-icon.svg"
import { ReactComponent as Location } from "../icons/location.svg"
import { ReactComponent as Email } from "../icons/email-icon.svg"
import { ReactComponent as Phone } from "../icons/phone-icon.svg"
import { ReactComponent as EyeOpen } from "../icons/eye-open.svg"
import { ReactComponent as Time } from "../icons/time-icon.svg"
import { ReactComponent as Google } from "../icons/google.svg"
import { ReactComponent as Quote1 } from "../icons/quote.svg"

const Icons = {
  ConferenceSolidStandard,
  AttachmentStrokeSharp,
  CustomerServiceSolid,
  InvoiceStrokeRounded,
  CloudDownloadSolid,
  ViewStrokeStandard,
  ChatStrokeRounded,
  UserMultipleSolid,
  CircleArrowRight,
  ThumbsDownStroke,
  CheckmarkSquare,
  ThumbsDownSolid,
  HealtcareSolid,
  ProgressStroke,
  ThumbsUpStroke,
  ComplaintSolid,
  UserGroupSolid,
  BookOpenSolid,
  CalendarSolid,
  ForumBookmark,
  ResetPassword,
  WellnessSolid,
  ThumbsUpSolid,
  CircleStroke,
  SaleTagSolid,
  SquareStroke,
  ViewOffSolid,
  ArrowRightUp,
  ArrowRight1,
  ArrowRight2,
  Appointment,
  DeleteSolid,
  TargetSolid,
  UploadSolid,
  ArrowDown1,
  ImageSolid,
  MinusSolid,
  QuizSolid1,
  RadioSolid,
  RouteSolid,
  SetupSolid,
  ShareSolid,
  ArrowDown,
  Backward1,
  Checkmark,
  EditSolid,
  ForumLike,
  Instagram,
  ListSolid,
  PlaySolid,
  PlusSolid,
  QuizSolid,
  SentPlane,
  TickSolid,
  ViewSolid,
  TwitterX,
  LinkedIn,
  Facebook,
  Dribbble,
  ForumAdd,
  ForumAll,
  Location,
  Comment1,
  TagSolid,
  Twitter,
  Comment,
  Google,
  Receipt,
  EyeOpen,
  Filter,
  Quote1,
  Search,
  Alert,
  Cross,
  Draft,
  Email,
  Heart,
  Phone,
  Quote,
  User1,
  Menu,
  Star,
  Time,
}

export default Icons